module.exports = __webpack_public_path__ + "82d0cd39c32d051c567a79668200835f.png";